module.exports = __webpack_public_path__ + "img/almalinux.4dbd5699.png";